import React, { useEffect, useState } from "react";
import Image from "react-bootstrap/Image";
import { Link, useSearchParams } from "react-router-dom";
import logoIcon from "../../assets/images/logoIcon.svg";
import { ROUTES } from "../../utils/routes";
import { Typography, CircularProgress } from "@mui/material";
import { api } from "../../utils/api";
import { endpoints } from "../../utils/endpoints";

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [status, setStatus] = useState("verifying"); // verifying, success, error
    const [message, setMessage] = useState("Verifying your email...");

    useEffect(() => {
        if (!token) {
            setStatus("error");
            setMessage("Invalid verification link.");
            return;
        }

        api.postApiCall(
            endpoints.verifyEmail, // Make sure to add this endpoint to utils/endpoints
            { token },
            (respData) => {
                if (respData.data.status === "SUCCESS") {
                    setStatus("success");
                    setMessage("Email verified successfully! You can now login.");
                } else {
                    setStatus("error");
                    setMessage(respData.data.message || "Verification failed. The link may have expired.");
                }
            },
            (error) => {
                setStatus("error");
                setMessage(error?.data?.message || "Something went wrong. Please try again.");
            }
        );
    }, [token]);

    return (
        <div className="loginPage signupbg wrap d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', padding: '20px' }}>
            <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-10 col-sm-12 col-12 mx-auto">
                <div className="bg-white p-5 rounded-4 shadow-sm text-center d-flex flex-column align-items-center justify-content-center" style={{ maxWidth: '600px', margin: '0 auto' }}>
                    <div className="logoIcon mb-4">
                        <Image src={logoIcon} alt="Logo Icon" style={{ maxHeight: '60px' }} />
                    </div>

                    {status === "verifying" && (
                        <div className="d-flex flex-column align-items-center mt-3">
                            <CircularProgress className="mb-3" />
                            <Typography variant="h5" className="text-secondary">Verifying...</Typography>
                        </div>
                    )}

                    {status === "success" && (
                        <>
                            <Typography variant="h4" className="mb-3 fw-bold">
                                Verification <span className="textGradient">Successful</span>
                            </Typography>
                            <Typography variant="body1" className="mb-4 text-muted" style={{ maxWidth: '80%' }}>
                                {message}
                            </Typography>
                            <Link to={ROUTES.LOGIN} className="btnPrimary text-decoration-none px-5 py-2">
                                Continue to Login
                            </Link>
                        </>
                    )}

                    {status === "error" && (
                        <>
                            <Typography variant="h4" className="mb-3 text-danger fw-bold">
                                Verification Failed
                            </Typography>
                            <Typography variant="body1" className="mb-4 text-muted" style={{ maxWidth: '80%' }}>
                                {message}
                            </Typography>
                            <Link to={ROUTES.LOGIN} className="btnPrimary text-decoration-none px-5 py-2">
                                Back to Login
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
